export default __webpack_public_path__ + "static/media/7.8d5b3d43.svg";